import { Component, OnInit, ViewChildren, QueryList, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ThrowStmt } from '@angular/compiler';
import { ServiceService } from 'src/app/service.service';
import {Location} from '@angular/common';
import { StreamingMedia, StreamingVideoOptions } from '@ionic-native/streaming-media/ngx';

import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-casosExito',
  templateUrl: './casosExito.page.html',
  styleUrls: ['./casosExito.page.scss' , '../../../assets/scss/styles.scss'],
})
export class CasosExitoPage implements OnInit {

  //feed = data;

  //GET ALL ELEMENTS BY ID = PLAYER
  @ViewChildren('player')videoPlayers:QueryList<any>; 
  //
  currentPlaying = null;
  //
  stickyVideo: HTMLVideoElement = null;
  stickyPlaying = false;
  isWeb:boolean = false;
  @ViewChild('stickyplayer', {static:false})stickyPlayer: ElementRef;
  //
  constructor(
    private renderer: Renderer2,
    public services:ServiceService,
    private _location: Location,
    private streamingMedia: StreamingMedia,
    private firebaseAnalytics: FirebaseAnalytics,
    private platform: Platform
    ) {
      this.firebaseAnalytics.logEvent;
      this.firebaseAnalytics.setCurrentScreen("Casos de Éxito");
      this.isWeb = this.platform.is('desktop');
     }

  ngOnInit() {
  }

  backClicked() {
    this._location.back();
  }

  didScroll(){
    if (this.currentPlaying && this.isElementInViewport(this.currentPlaying)) {
      return;
    } else if (this.currentPlaying && !this.isElementInViewport(this.currentPlaying)) {
      // item is out of view, pause it
      this.currentPlaying.pause();
      this.currentPlaying = null;
    }
    
    this.videoPlayers.forEach(player => {
      //console.log('player:',player);
      if(this.currentPlaying){
        return;
      }

      const nativeElement = player.nativeElement;
      const inView = this.isElementInViewport(nativeElement);

      //verify the stickyvideo is playing
      if (this.stickyVideo && this.stickyVideo.src == nativeElement.src) {
        return;
      }

      if (inView){
        this.currentPlaying = nativeElement;
        this.currentPlaying.muted = true;
        this.currentPlaying.play();
      }

    });
  }

  openFullscreen(elem){
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitEnterFullscreen) {
      elem.webkitEnterFullscreen();
      elem.enterFullscreen();
    }
  }

  muteVideo(elem){
    if (elem.muted){
      elem.muted = false;
      //console.log("sound");
      //icon["el"].attributes.name = "volume-high-outline";
    } else {
      elem.muted = true;
      //console.log("muted");
      //icon["el"].attributes.name = "volume-mute-outline";
    }
  }

  mutedVideo(elem){
    return elem.muted;
  }

  //
  isElementInViewport(el){
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  playOnSide(elem){
    if(this.stickyVideo){
      this.renderer.removeChild(this.stickyPlayer.nativeElement,this.stickyVideo);
    }
    
    this.stickyVideo = elem.cloneNode(true);
    this.renderer.appendChild(this.stickyPlayer.nativeElement,this.stickyVideo);

    if(this.currentPlaying){
      const playPosition = this.currentPlaying.currentTime;
      this.currentPlaying.pause();
      this.currentPlaying.muted = true;
      this.currentPlaying = null;
      this.stickyVideo.currentTime = playPosition;
    }

    this.stickyVideo.muted = false;
    this.stickyVideo.play();
    this.stickyPlaying = true;

  }

  closeSticky(){
    if(this.stickyVideo){
      this.renderer.removeChild(this.stickyPlayer.nativeElement,this.stickyVideo);
      this.stickyVideo = null;
      this.stickyPlaying = false;
    }
  }
  
  playOrPauseSticky(){
    if (this.stickyPlaying) {
      this.stickyVideo.pause();
      this.stickyPlaying = false;
    } else {
      this.stickyVideo.play();
      this.stickyPlaying = true;
    }
  }

  autoPlay1(){
    const options: StreamingVideoOptions = {
      successCallback: () => { console.log('Video played'); },
      errorCallback: (e) => { console.log('Error streaming'); },
      orientation: 'landscape',
      shouldAutoClose: true,
      controls: true
    };

    this.streamingMedia.playVideo('https://test-bucket-72bc5c3f-5c53-4442-9610-58d5c984afb1.s3.amazonaws.com/Resources/CASO+DE+EXITO+1.mp4', options);
  }

  autoPlay2(){
    const options: StreamingVideoOptions = {
      successCallback: () => { console.log('Video played'); },
      errorCallback: (e) => { console.log('Error streaming'); },
      orientation: 'landscape',
      shouldAutoClose: true,
      controls: true
    };

    this.streamingMedia.playVideo('https://test-bucket-72bc5c3f-5c53-4442-9610-58d5c984afb1.s3.amazonaws.com/Resources/CASO+DE+EXITO+2.mp4', options);
  }
}
